import Constant from '@/const';
import axios from 'axios';

const getPreparation = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/master/preparation'),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getPreparation;
